import React from 'react'
import Link from 'gatsby-link'

const Footer = () => (
  <footer className="site-footer bg-darkest" role="contentinfo">
    <div className="container">

      <ul className="nav justify-content-center">
        <li className="nav-item">
          <Link to="#" className="nav-link">
            Privacy Policy
          </Link>
        </li>
        <li className="nav-item">
          <Link to="#" className="nav-link">
            Terms
          </Link>
        </li>
        <li className="nav-item">
          <Link to="#" className="nav-link">
            Feedback
          </Link>
        </li>
        <li className="nav-item">
          <Link to="#" className="nav-link">
            Advertise
          </Link>

        </li>
        <li className="nav-item">
          <Link to="page-contact" className="nav-link">
            Contact
          </Link>
        </li>
      </ul>
      <div className="copy">
        &copy; ketostrive 2018<br/>
        All rights reserved
      </div>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js